import { render, staticRenderFns } from "./AddProduct.vue?vue&type=template&id=146529e6&scoped=true&"
import script from "./AddProduct.vue?vue&type=script&lang=js&"
export * from "./AddProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146529e6",
  null
  
)

export default component.exports